document.addEventListener("DOMContentLoaded", function() {
  //BASIC INFO
  const basicInfoEl = document.querySelector(".gtm--basic_info_event");
  if (basicInfoEl) {
      //get necessary dynamic data
      let pageType = basicInfoEl.querySelector(".page_type")?.value;
      let pageTitle = basicInfoEl.querySelector(".page_title")?.value;
      let currentLanguage = basicInfoEl.querySelector(".current_language")?.value;
      let currentMarket = basicInfoEl.querySelector(".current_market")?.value;
      let page_id = basicInfoEl.querySelector(".page_id")?.value;

      if (pageType === 'index') {
          pageType = 'home'
      } else if (pageType === 'page') {
          pageType = 'other'
      }

      function getCurrentLocalization() {
          const pathSegments = window.location.pathname.split('/');

          for (const path of pathSegments) {
              if (path.length === 5 || path.length === 2)  {
                  if (path.match(/^[a-z]{2}(-[a-z]{2})?$/i)) {
                      const [language, market] = path.split('-');
                      return { current_language: language, current_market: market || null };
                  }
                  return { current_language: null, current_market: null };
              }
          }
          return { current_language: null, current_market: null };
      }

      const { current_language, current_market } = getCurrentLocalization();

      //clear dataLayer
      window.dataLayer =  window.dataLayer || [];
      window.dataLayer.push({
          event: "basic_info",
          page_type: pageType,
          page_title: pageTitle,
          current_language: currentLanguage || current_language,
          current_market: current_market || currentMarket,
          ...(page_id && {page_id: page_id })
      });
  }

  //USER LOGIN/LOGOUT
  const customerCheck = document.querySelector(".gtm--user_data");
  if (customerCheck) {
      //get necessary dynamic data
      let userType = customerCheck.querySelector(".user_type").value;
      let customerId = customerCheck.querySelector(".customer_id")?.value;
      let ordersCount = customerCheck.querySelector(".orders_count")?.value;
      let totalSpent = customerCheck.querySelector(".total_spent")?.value;
      let lastOrderDate = customerCheck.querySelector(".last_order_date")?.value;

      //clear dataLayer
      window.dataLayer =  window.dataLayer || [];
      window.dataLayer.push({
          event: "user_data",
          user_type: userType,
          ...(customerId && { customer_id: customerId }),
          ...(ordersCount && { orders_count: ordersCount }),
          ...(totalSpent && { total_spent: totalSpent }),
          ...(lastOrderDate && { last_order_date: lastOrderDate })
      });
  }
});

fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        const cartData = [];

        const productFetchPromises = cart.items.map((item, index) => {
            return fetch(`/products/${item.handle}.js`)
                .then(response => response.json())
                .then(product => {

                  const priceValue = parseInt(product.price)
                  const comparePrice = product.variants.find(variant => variant.id === item.id)?.compare_at_price
                  const variantComparedPrice =parseInt(product.variants.find(variant => variant.id === item.id)?.compare_at_price || item.price)

                  const formattedPrice =  priceValue/100
                  const formattedComparePrice = comparePrice ? comparePrice/100 : null
                  const formattedVariantComparedPrice = variantComparedPrice/100
                   let cartDataObj = {
                        item_name: item.product_title,
                        item_id: item.id,
                        item_variant: item.variant_title,
                        item_brand: item.vendor,
                        index: index + 1,
                        price: formattedPrice,
                        compare_at_price: parseFloat(formattedComparePrice) || null,
                        discount : parseFloat((parseFloat(formattedVariantComparedPrice) - parseFloat(formattedPrice)).toFixed(2)),
                        quantity: item.quantity,
                    };

                    cartData.push(cartDataObj);
                });
        });

        Promise.all(productFetchPromises)
            .then(() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                  event: "cart_data",
                  cart_data_value: cart.total_price / 100,
                  cart_data_currency: cart.currency,
                  cart_data_items: cartData
              })
            })
            .catch(error => console.error('Error fetching product data:', error));
    })
    .catch(error => console.error('Error fetching cart:', error));
